import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import U2000InputDate from '../../../u2000Core/components/formControls/input/U2000InputDate';
import { NS } from '../../U3147';
import { u3147FormatDecimalHours, u3147ShiftIsoDate, u3147TodayIsoDate } from '../../tools/u3147FormatDuration';

export interface U3147DayBarProps {
  selectedDate: string;
  totalHours: number;
  onDateChange: (date: string) => void;
}

const U3147_DAY_BAR_CONTROL_H = 'h-[46px]';

const U3147DayBar: React.FC<U3147DayBarProps> = ({ selectedDate, totalHours, onDateChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-none border border-b-0 border-gray-200 bg-gray-50 px-4 py-3">
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          className={`inline-flex ${U3147_DAY_BAR_CONTROL_H} w-[46px] shrink-0 items-center justify-center rounded-lg border border-gray-300 bg-white hover:bg-gray-100`}
          aria-label={t('btnPrevDay', { ns: NS, defaultValue: 'Jour précédent' })}
          onClick={() => onDateChange(u3147ShiftIsoDate(selectedDate, -1))}
        >
          <FaChevronLeft className="h-4 w-4" />
        </button>
        <U2000InputDate
          value={selectedDate.slice(0, 10)}
          onChange={onDateChange}
          className="w-44 min-w-44 shrink-0"
        />
        <button
          type="button"
          className={`inline-flex ${U3147_DAY_BAR_CONTROL_H} w-[46px] shrink-0 items-center justify-center rounded-lg border border-gray-300 bg-white hover:bg-gray-100`}
          aria-label={t('btnNextDay', { ns: NS, defaultValue: 'Jour suivant' })}
          onClick={() => onDateChange(u3147ShiftIsoDate(selectedDate, 1))}
        >
          <FaChevronRight className="h-4 w-4" />
        </button>
        <button
          type="button"
          className={`inline-flex ${U3147_DAY_BAR_CONTROL_H} shrink-0 items-center rounded-lg border border-blue-200 bg-blue-50 px-3 text-sm font-medium text-blue-800 hover:bg-blue-100`}
          onClick={() => onDateChange(u3147TodayIsoDate())}
        >
          {t('btnToday', { ns: NS, defaultValue: "Aujourd'hui" })}
        </button>
      </div>
      <div className="text-sm text-gray-700">
        {t('lblTotalDay', { ns: NS, defaultValue: 'Total du jour' })} :{' '}
        <strong>{u3147FormatDecimalHours(totalHours)} h</strong>
      </div>
    </div>
  );
};

export default U3147DayBar;
